// @flow

import React, { type Node } from 'react';
import { DisplayBrand } from '../commons';
import transferenciaElectronicaIconSrc from './transferencia-electronica-icon.svg';

export function DisplayTransferenciaElectronicaBrand(): Node {
  return <DisplayBrand iconSrc={transferenciaElectronicaIconSrc} iconAlt="Transferencia Electrónica" />;
}
